/* eslint-disable  no-unused-vars*/
import { useRootInstance } from './useRootInstance';

export function useI18n(): {
  t: (...args: any[]) => string;
  tc: (...args: any[]) => string;
  d: (...args: any[]) => string;
  te: (...args: any[]) => string;
  n: (...args: any[]) => string;
  } {
  const vm = useRootInstance();

  if (!vm.$i18n) {
    Object.defineProperty(vm, '$i18n', {
      get: function get() {
        return this._i18n;
      }
    });
  }

  return {
    t: vm.$t.bind(vm),
    tc: vm.$tc.bind(vm),
    d: vm.$d.bind(vm),
    te: vm.$te.bind(vm),
    n: vm.$n.bind(vm)
  };
}
